import BaseApi from "./BaseApi";

export const getConfig = async lang => {
  return await BaseApi.get(`/cdn/GetBeConfig?lang=${lang}`);
};



// WEBPACK FOOTER //
// ./src/api/config.js